<!--
* 组件名 : 视频轮播器
* 开发者 : JY
*
* 参数:
*   videoData         { Array } -  视频列表数据
* 事件: null
*
-->

<template>
  <div class="video-carousels">
    <div class="tabs" id="video-tabs" ref="tabs">
      <ul class="label-list">
        <li v-for="(item, i) in videoData" :key="i">{{ item.title }}</li>
      </ul>
    </div>
    <div class="video-content-wrap" ref="videoContentWrap">
      <transition name="fade">
        <div id="video-swiper" ref="videoSwiper" v-if="isFade">
          <v-video-card
            v-for="(el, n) in videolistData"
            :key="n"
            :vid="el.vid"
            :desc="el.description"
            :poster="el.poster"
            :title="el.title"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Tabs from "@/vendor/tabs.min.js";
import { timeout } from "@/utils/util";
export default {
  name: "video-carousels",
  props: {
    videoData: {
      type: Array,
      required: true,
    },
  },
  data() {
    this.tabs = null;
    return {
      isFade: true,
      videolistData: {},
    };
  },
  components: {},
  created() {
    this.videolistData = this.videoData[0].lists;
  },
  mounted() {
    this.plugins_init();
    this.tabs_change();
    this.set_video_box_height();
  },

  methods: {
    /**
     * 视频打组(保留思路)
     */
    video_list_pangkat() {
      $(this.$refs.videoContentWrap)
        .find(".v-video-card")
        .map((i, item) => {
          let parentArr = [...$(item).find(".video-card")];
          let newArr = [];

          for (let n = 0; n < parentArr.length; ) {
            newArr.push(parentArr.slice(n, (n += 6)));
          }

          for (let s = 0; s < newArr.length; s++) {
            $(item).append(
              $(`<div class="videos-slides d-flex swiper-slide" />`).append(
                newArr[s]
              )
            );
          }
        });
    },
    /**
     * 插件调用
     */
    async plugins_init() {
      //  Tabs 插件
      this.tabs = new Tabs({ el: "#video-tabs" });
    },

    /**
     * tab 切换
     */
    tabs_change() {
      let $li = $(this.$refs.tabs).find("li");

      this.tabs.on("change", async (event, index) => {
        this.isFade = false;
        this.videolistData = this.videoData[index].lists;
        $li.css({ "pointer-events": "none" });
        await timeout(280);
        this.isFade = true;
        $li.css({ "pointer-events": "" });
        this.set_video_box_height();
      });
    },

    /**
     * 初始化盒子高度
     */
    set_video_box_height() {
      let videoContent = this.$refs.videoContentWrap;
      timeout(100).then(() => {
        videoContent.style.height = `${videoContent.firstChild.clientHeight}px`;
      });
    },
  },
};
</script>

<style lang="scss">
.video-carousels {
  width: 1248px;
  margin: auto;
  overflow: hidden;

  .videos-slides {
    width: 100%;
    flex-wrap: wrap;
  }
}

#video-tabs {
  margin-bottom: 32px;
  justify-content: center;

  .label-list {
    width: auto;
    li {
      font-size: 18px;
      &:hover,
      &.current {
        color: $color-hover-text;
      }
    }
    .indicator {
      background: $color-hover-text;
    }
  }

  .overflow-arrow {
    background: #fae6d2;
    cursor: pointer;

    &::after {
      background: linear-gradient(
        to right,
        #fae6d2 0%,
        rgba(250, 230, 210, 0) 100%
      );
    }
  }
}

#video-swiper {
  min-height: 40vh;
  display: flex;
  flex-wrap: wrap;
}

.video-content-wrap {
  position: relative;
  transition: height 0.6s ease;
  margin-bottom: 94px;
  overflow: hidden;

  .linear-btn {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 600;

    &.slick-prevs {
      left: -80px;
    }

    &.slick-nexts {
      right: -80px;
    }
  }
}

@media (max-width: $lx-min) {
  .video-carousels {
    width: 998px;

    .video-card {
      width: 300px;
    }
  }
}
</style>
